import { render } from "./QuizCompleteOverlay.vue?vue&type=template&id=bfa07036"
import script from "./QuizCompleteOverlay.vue?vue&type=script&lang=js"
export * from "./QuizCompleteOverlay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__